/*
let elHeader: HTMLElement;
let elMenu: HTMLElement;
let elLogo: HTMLElement;
let elQuoteButton: HTMLElement;
let elMenuToggle: HTMLElement;
*/

function init() {
  const elHeader : HTMLElement = document.querySelector('.siteHeader');
  const elMenuToggle = elHeader.querySelector('.btn-menu');
  
  /*
  elMenu = elHeader.querySelector('.headerNav');
  elLogo = elHeader.querySelector('headerLogo');
  elQuoteButton = elHeader.querySelector('btn-quote');
  */
  elMenuToggle.addEventListener('click', () => toggleMenu(elHeader));
}

function toggleMenu(elHeader: HTMLElement) {
  elHeader.classList.toggle('siteHeader--menuOpen');
}

const Header = { init };

export default Header;